<form [formGroup]="requirementForm" autocomplete="off" class="form-container">
  <div class="row w-100 m-0 p-0">
    <mat-form-field appearance="outline" class="col-lg-8 m-auto">
      <mat-label>Ingresa el detalle de tu requerimiento</mat-label>
      <textarea matInput #requerimiento name="requerimiento" formControlName="detail" type="text" rows="5" max-rows="6"
        maxlength="300" required></textarea>
      <mat-hint align="end">{{requerimiento.value.length}} / 300</mat-hint>
      <mat-error *ngIf="requirementForm.get('detail').hasError('required')">
        El detalle es <strong>requerido</strong>.
      </mat-error>
      <mat-error *ngIf="requirementForm.get('detail').hasError('minlength')">
        El detalle mínimo debe tener <strong>1 carácter</strong>.
      </mat-error>
    </mat-form-field>
    <div class="col-lg-4">
      <mat-label style="font-size: 1.05rem;">Vía de respuesta preferida:</mat-label>
      <ng-container *ngFor="let item of contact; let i = index" formArrayName="contact">
        <mat-checkbox [value]="item" [formControlName]="i" (change)="existsValue()">
          <span class="chxLabel">{{item.name}}</span>
        </mat-checkbox>
      </ng-container>
    </div>
  </div>
</form>